module.exports = __webpack_public_path__ + "static/media/check.49aca034.svg";